import {  client  } from "./index";

export const getAppList = (token) => client.get(`azure_usermanagment/app`, { headers: {"Authorization" : `Bearer ${token}`} } );
